export default {
  store: null,
  stores: null,
};
